import script from "./BaseFixedAsideElementMobileToggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseFixedAsideElementMobileToggle.vue?vue&type=script&lang=ts&setup=true"

import "./BaseFixedAsideElementMobileToggle.vue?vue&type=style&index=0&id=71457dcc&lang=scss"

const __exports__ = script;

export default __exports__